// SCSS
import "../scss/style.scss";

import Alpine from 'alpinejs';
import persist from '@alpinejs/persist';

Alpine.plugin(persist);
window.Alpine = Alpine;
Alpine.start();

// JS Components
import "./components/_accordion";
import "./components/_burger";
import "./components/_lang";
import "./components/_modal";
import "./components/_navigation";
import "./components/_select";
import "./components/_tabs";
import "./components/_map";
import "./components/_light-gallery";

import "./pages/home";
